import { create } from 'zustand';

export const useProductStore = create(set => ({
  activeVariant: false,
  setActiveVariant: value => set({ activeVariant: value })
}));
